import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=14adc2cf&scoped=true&"
import script from "./InfoText.vue?vue&type=script&lang=js&"
export * from "./InfoText.vue?vue&type=script&lang=js&"
import style0 from "./info-text.scss?vue&type=style&index=0&id=14adc2cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14adc2cf",
  null
  
)

export default component.exports